import { Observable } from 'rxjs';
import { StatusCapaciteEnum } from './latest/constants/status-capacite.enum';

export abstract class ToolCapaciteService {
  abstract version: string;

  abstract isCapacityFormInProgress$: Observable<boolean>;

  abstract donneesResultat$: Observable<any>;

  abstract statutCapacite$: Observable<StatusCapaciteEnum>;

  abstract donneesCapacite$: Observable<any>;

  abstract totalDepenses$: Observable<any>;

  abstract totalEngagements$: Observable<any>;

  abstract donneesEtapeMiseFonds$: Observable<any>;

  abstract isCapacityCompleted$: Observable<any>;

  abstract isCapacityCompletedAndLoaded$: Observable<any>;

  abstract dashboardComponent: unknown;
  abstract debugComponent: unknown;
  abstract conseilsComponent: unknown;

  abstract initialize(): Promise<void>;

  abstract patchDebugOnly(data: Partial<any>, isCompleted: boolean);

  abstract modifierEtape(etape: string, returnUrl: string);
}
